//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'select-activity-modal',
    props: {
        onSelected: Function
    },
    data() {
        return {
            loading: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    key: 'activityName',
                    title: '活动名称'
                },
                {
                    title: '活动类型',
                    key: 'activityTypeStr'
                },
                {
                    title: '开始时间',
                    key: 'startDateTimeStr'
                    // width: 110
                },
                {
                    title: '结束时间',
                    key: 'endDateTimeStr'
                    // width: 110

                },
                {
                    title: '是否报名',
                    key: 'isSignUp',
                    width: 99,
                    render: (h, params) => {
                        return h('span', params.row.isSignUp ? '是' : '否');
                    }
                },
                {
                    title: '活动状态',
                    key: 'activityStatusStr',
                    width: 99
                }
            ],
            searchInput: {
                activityStatus: 1
            }
        };
    },
    computed: {
        list() {
            return this.$store.state.activity.list;
        },
        currentPage() {
            return this.$store.state.activity.currentPage;
        },
        pageSize() {
            return this.$store.state.activity.pageSize;
        },
        totalCount() {
            return this.$store.state.activity.totalCount;
        }
    },
    methods: {
        pageChange(page) {
            this.$store.commit('activity/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('activity/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            await this.$store.dispatch({
                type: 'activity/getAll',
                data: this.searchInput
            });
        },
        onRowClick(row, index) {
            const vm = this;
            if (vm.onSelected !== undefined) {
                vm.onSelected(row);
            }
        }
    },
    created() {
        this.getPage();
    }
};
